import { Copy, CircleHelp, StickyNote } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from 'src/shared/components/ui/popover';
import IconButton from 'src/shared/components/ui/buttons/icon-button';
import WithTooltip from 'src/shared/components/utils/WithTooltip';
import { cn } from 'src/shared/lib/utils';

interface FooterProps {
  supportUrl: string;
  className?: string;
  onLogout: () => void;
  showHamburgerMenu?: boolean;
  threadId?: string;
  onAddNote?: () => void;
}

export default function Footer({
  supportUrl,
  className,
  onLogout,
  showHamburgerMenu = false,
  threadId,
  onAddNote,
}: FooterProps) {
  if (showHamburgerMenu) {
    return (
      <div className={cn('bg-white border-t w-full flex-center py-4', className)}>
        <div className="flex justify-between items-center w-[90%]">
          <Popover>
            <PopoverTrigger asChild>
              <IconButton aria-label="menu" icon="Menu" />
            </PopoverTrigger>
            <PopoverContent align="start" side="top" className="w-[240px] p-1">
              {onAddNote && (
                <button
                  onClick={onAddNote}
                  className="w-full flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm text-typography-black hover:bg-neutral-100 transition-colors"
                >
                  <StickyNote size={16} />
                  Add internal note
                </button>
              )}
              {threadId && (
                <button
                  onClick={() => navigator.clipboard.writeText(threadId)}
                  className="w-full flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm text-typography-black hover:bg-neutral-100 transition-colors"
                >
                  <Copy size={16} />
                  Copy thread ID
                </button>
              )}
              <button
                onClick={() => window.open(supportUrl)}
                className="w-full flex items-center gap-2 px-2 py-1.5 rounded-sm text-sm text-typography-black hover:bg-neutral-100 transition-colors"
              >
                <CircleHelp size={16} />
                Help
              </button>
            </PopoverContent>
          </Popover>
          <IconButton aria-label="logout" icon="LogOut" onClick={onLogout} />
        </div>
      </div>
    );
  }

  return (
    <div className={cn('bg-white border-t w-full flex-center py-4', className)}>
      <div className="flex justify-between items-center w-[90%]">
        <div role="group" aria-label="Account controls" className="flex items-center justify-center">
          <WithTooltip tooltip="Logout" delay={300}>
            <IconButton aria-label="logout" icon="LogOut" onClick={onLogout} />
          </WithTooltip>
        </div>
        <WithTooltip tooltip="Support" delay={300} aria-label="Open support">
          <IconButton icon="CircleQuestionMark" onClick={() => window.open(supportUrl)} />
        </WithTooltip>
      </div>
    </div>
  );
}
